<template>
    <div class="text-center my-3">
        <h3 class="font-weight-bold">
            <v-icon>mdi-account-group-outline</v-icon>
            DANH SÁCH ROLES
        </h3>

    </div>
    <v-container>
        <v-row class="mb-3 d-flex justify-center mx-auto" style="width: auto">
            <v-col cols="12" md="5">
                <v-combobox hide-details :return-object="false" v-model="cbxCompany" :items="dataCompany"
                    item-title="CompanyName" item-value="CompanyID" label="Chọn công ty"></v-combobox>
            </v-col>
            <v-col cols="12" md="5">
                <v-combobox hide-details :return-object="false" v-model="cbxProject" :items="dataProject"
                    item-title="ProjectName" item-value="ProjectID" label="Chọn projects"></v-combobox>
            </v-col>
            <v-col cols="12" md="2" class="d-flex align-center justify-center ml-n4">
                <v-btn :disabled="cbxProject === null ? true : false" elevation="0" color="primary"
                    @click="openDialogUpdateRole(null)">
                    <v-icon class="mr-2">mdi-plus-circle</v-icon>
                    Thêm mới
                </v-btn>
            </v-col>
        </v-row>

        <v-table style="width: 1000px" class="mx-auto">
            <thead>
                <tr>
                    <th> Mã role </th>
                    <th> Tên role </th>
                    <th> Tên công ty </th>
                    <th> Mô tả </th>
                    <th> Thêm user </th>
                    <th> Thao tác </th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="item in dataRole" :key="item.RoleID">
                    <td>{{ item.RoleID }}</td>
                    <td>{{ item.RoleName }}</td>
                    <td>{{ item.CompanyName }}</td>
                    <td>{{ item.Description }}</td>
                    <td><v-icon color="primary" @click="openDialogUser(item)">mdi-plus-circle</v-icon>
                    </td>
                    <td>
                        <div style="display: flex; gap: 2px; align-items: center;">
                            <v-icon color="primary" @click="openDialogUpdateRole(item)">mdi-pencil</v-icon>
                            <v-icon color="red" @click="showDialogDeleteConfirm(item)">mdi-delete</v-icon>
                        </div>

                    </td>
                </tr>
            </tbody>
        </v-table>
    </v-container>

    <!-- Hộp thoại Thêm, sửa dữ liệu -->
    <v-dialog width="500" scrollable v-model="showDialogUpdate">
        <template v-slot:default="{ isActive }">
            <v-card prepend-icon="mdi-pencil-plus-outline" :title="dialogUpdateTitle">
                <v-divider class="mb-3"></v-divider>

                <v-text-field class="mx-4" v-model="objRole.RoleName" label="Tên" variant="outlined"></v-text-field>

                <v-text-field class="mx-4" v-model="objRole.Description" label="Mô tả"
                    variant="outlined"></v-text-field>
                <v-divider></v-divider>

                <v-card-actions>
                    <v-btn text="ĐÓNG" @click="isActive.value = false"></v-btn>
                    <v-spacer></v-spacer>
                    <v-btn color="success" text="LƯU" variant="flat" @click="saveUpdateAction()"></v-btn>
                </v-card-actions>
            </v-card>
        </template>
    </v-dialog>

    <!-- Hộp thoại xác nhận xóa -->
    <v-dialog v-model="showDialogDelete" max-width="500px">
        <v-card>
            <v-card-title class="headline">Xác nhận xoá</v-card-title>
            <v-divider class="mb-3"></v-divider>
            <v-card-text class="text-center">
                Bạn có chắc xoá dữ liệu không?
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="gray" variant="flat" text @click="showDialogDelete = false">Huỷ</v-btn>
                <v-btn color="red" variant="flat" text @click="deleteAction()">Đồng ý</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>


    <v-dialog width="900px" scrollable v-model="showDialogUser">
        <template v-slot:default="{ isActive }">
            <v-card prepend-icon="mdi-pencil-plus-outline" title="Chọn người dùng">
                <v-divider class="mb-3"></v-divider>

                <v-container>
                    <v-row>
                        <!-- Bảng danh sách tất cả user -->
                        <v-col cols="12" md="5">
                            <v-card>
                                <v-card-title class="text-subtitle-1">Danh sách user chưa thêm vào Roles</v-card-title>
                                <v-data-table hide-default-footer v-model="selectedUserLeft" :items="dataUser" item-value="UserID" show-select
                                :headers="headersUser" class="elevation-1"></v-data-table>
                            </v-card>
                            
                        </v-col>

                        <!-- Nút chuyển dữ liệu (Hiển thị ngang trên desktop, dọc trên mobile) -->
                        <v-col cols="12" md="2" class="d-flex flex-column align-center justify-center">
                            <v-btn @click="moveToRight" :disabled="selectedUserLeft.length === 0" color="primary"
                                class="mb-2">
                                <v-icon>mdi-arrow-right</v-icon>
                            </v-btn>
                            <v-btn @click="moveToLeft" :disabled="selectedUserRight.length === 0" color="error">
                                <v-icon>mdi-arrow-left</v-icon>
                            </v-btn>
                        </v-col>

                        <!-- Bảng danh sách user đã có trong Role -->
                        <v-col cols="12" md="5">
                            <v-card>
                                <v-card-title class="text-subtitle-1">Danh sách user đã thêm vào Roles</v-card-title>
                                <v-data-table hide-default-footer v-model="selectedUserRight" :items="dataUserInRole" item-value="UserID"
                                show-select :headers="headersUser" class="elevation-1"></v-data-table>
                            </v-card>
                            
                        </v-col>
                    </v-row>
                </v-container>

                <v-divider></v-divider>

                <v-card-actions>
                    <v-btn text="ĐÓNG" @click="isActive.value = false"></v-btn>
                    <v-spacer></v-spacer>
                    <v-btn color="success" text="LƯU" variant="flat" @click="saveUpdateUser()"></v-btn>
                </v-card-actions>
            </v-card>
        </template>
    </v-dialog>



</template>
<script>
import axios from '../utils/axios'
export default {
    name: 'QuanLyRolesComponent',
    data: () => ({
        dataRole: [],
        dataCompany: [],
        dataUser: [],
        dataProject: [],
        cbxCompany: null,
        cbxProject: null,
        showDialogUpdate: false,
        showDialogDelete: false,
        showDialogUser: false,
        selectedUser: [],
        selectedUserLeft: [],
        selectedUserRight: [],
        dataUserInRole: [],
        dialogUpdateTitle: "",
        objRole: {
            RoleID: null,
            RoleName: "",
            Description: "",
            CompanyID: null,
        },
        errorMessage: "",
        colorMessage: "blue",
        headersUser: [{
            title: "Tên đăng nhập",
            key: "Username"
        },
        {
            title: "Họ tên",
            key: "FullName"
        }
        ]
    }),
    mounted() {
        this.getRole()
        this.getCompany()
        this.getProject()
    },
    watch: {

        async cbxCompany() {
            this.getRole()
            this.getProject()
            await this.getUsers()
        },
        cbxProject() {
            this.getRole()
        }
    },
    methods: {
        getRole() {
            this.dataRole = []
            axios.post('/Role_SelectByCompany', {
                CompanyID: this.cbxCompany,
                ProjectID: this.cbxProject
            })
                .then((response) => { this.dataRole = [...response.data] })
                .catch((error) => { console.log(error); });
        },

        async getUserRole(id) {
            this.dataUserInRole = []
            await axios.post('/UserRole_SelectUserByRole', {
                RoleID: id
            })
                .then((response) => { 
                    if (response.data) {
                        response.data.forEach(i => {
                            this.dataUserInRole.push({ UserID: i.UserID, Username: i.Username, FullName: i.FullName })

                        });
                    }
                })
                .catch((error) => { console.log(error); });
            const kq = this.filterUniqueObjects(this.dataUser, this.dataUserInRole, "UserID")
            this.dataUser = kq.filteredA
        },
        async getUsers() {
            this.dataUser = []
            await axios
                .post("/User_SelectByCompany", {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem("auth")}` // Token lấy từ localStorage hoặc nơi lưu trữ của bạn
                    },
                    CompanyID: this.cbxCompany

                })
                .then((response) => {
                    console.log("API Response:", response.data);
                    // this.dataUser = response.data || [];
                    if (response.data) {
                        response.data.forEach(i => {
                            this.dataUser.push({ UserID: i.UserID, Username: i.Username, FullName: i.FullName })
                        });
                    }
                })
                .catch((error) => {
                    console.error("Error fetching users:", error);
                });
        },

        getCompany() {
            axios.get('/Company_SelectAll', {})
                .then((response) => { this.dataCompany = [...response.data] })
                .catch((error) => { console.log(error); });
        },

        getProject() {
            this.cbxProject = null;
            this.dataProject = []
            axios.post('/Project_SelectByCompany', {
                CompanyID: this.cbxCompany
            })
                .then((response) => { this.dataProject = [...response.data] })
                .catch((error) => { console.log(error); });
        },

        async openDialogUser(obj) {
            this.showDialogUser = true;
            this.dataUserInRole = [];
            await this.getUsers();
            await this.getUserRole(obj.RoleID);

            this.objRole.RoleID = obj.RoleID;
            this.objRole.RoleName = obj.RoleName;
            this.objRole.Description = obj.Description;
            this.objRole.CompanyID = obj.CompanyID;
            this.objRole.ProjectID = obj.ProjectID;
        },
        openDialogUpdateRole(obj) {
            this.showDialogUpdate = true;
            if (obj == null) {
                this.dialogUpdateTitle = "Thêm mới Roles"
                this.objRole.RoleName = "";
                this.objRole.Description = "";
                this.objRole.RoleID = null;
                this.objRole.CompanyID = this.cbxCompany;
                this.objRole.ProjectID = this.cbxProject;
            }
            else {
                this.dialogUpdateTitle = "Chỉnh sửa thông tin Roles"
                this.objRole.RoleID = obj.RoleID;
                this.objRole.RoleName = obj.RoleName;
                this.objRole.Description = obj.Description;
                this.objRole.CompanyID = obj.CompanyID;
                this.objRole.ProjectID = obj.ProjectID;
            }
        },
        moveToRight() {
            this.selectedUserLeft.forEach(user => {
                this.dataUserInRole.push(this.dataUser.find(v => v.UserID === user));  // Thêm vào danh sách bên phải
            });

            // Cập nhật danh sách bên trái (loại bỏ user đã chọn)
            this.dataUser = this.dataUser.filter(u => !this.dataUserInRole.includes(u));

            // Cập nhật danh sách đã chọn
            this.selectedUserLeft = [];
            this.selectedUserRight = []
        },

        moveToLeft() {
            this.selectedUserRight.forEach(user => {
                if (user) {
                    this.dataUser.push(this.dataUserInRole.find(v => v.UserID === user)); // Thêm vào danh sách bên trái

                }
            });

            // Cập nhật danh sách bên phải (loại bỏ user đã chọn)
            this.dataUserInRole = this.dataUserInRole.filter(u => !this.dataUser.includes(u));

            // // Cập nhật danh sách đã chọn
            this.selectedUserLeft = [];
            this.selectedUserRight = []
            // this.selectedUserRight = [...this.dataUserInRole];
        },


        saveUpdateUser() {

            axios.post('/UserRole_Add', {
                RoleID: this.objRole.RoleID,
                ListUser: this.dataUserInRole.map(v => v.UserID) //selectedUser
            }).then(() => {
                this.showDialogUser = false;
                this.getUsers(); // Cập nhật danh sách người dùng
                this.getUserRole();
            }).catch((error) => {
                console.error("Lỗi khi lưu:", error);
            });
        },


        saveUpdateAction() {
            if (this.objRole.RoleName == "")
                return;

            axios.post('/Role_Update',
                {
                    RoleID: this.objRole.RoleID,
                    RoleName: this.objRole.RoleName,
                    Description: this.objRole.Description,
                    CompanyID: this.objRole.CompanyID,
                    ProjectID: this.objRole.ProjectID
                })
                .then((response) => {
                    this.showDialogUpdate = false;
                    this.getRole();
                    this.errorMessage = response.data.message;
                    this.colorMessage = "blue";
                })
                .catch((error) => {
                    this.errorMessage = error.response.data.message;
                    this.colorMessage = "red";
                    this.showDialogUpdate = false;
                });
        },

        showDialogDeleteConfirm(obj) {
            this.objRole.RoleID = obj.RoleID;
            this.showDialogDelete = true;
        },

        deleteAction() {
            axios.post('/Role_Delete',
                {
                    RoleID: this.objRole.RoleID
                })
                .then((response) => {
                    this.getRole();
                    this.showDialogDelete = false;
                    this.errorMessage = response.data.message;
                    this.colorMessage = "blue";
                })
                .catch((error) => {
                    this.errorMessage = error.response.data.message;
                    this.colorMessage = "red";
                    this.showDialogDelete = false;
                });
        },
        filterUniqueObjects(arrA, arrB, key) {
            const setA = new Set(arrA.map(item => item[key]));
            const setB = new Set(arrB.map(item => item[key]));

            const filteredA = arrA.filter(item => !setB.has(item[key]));
            const filteredB = arrB.filter(item => !setA.has(item[key]));

            return { filteredA, filteredB };
        }
    }
}
</script>